import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { TranslationKeyMap } from '../gp-main.i18n';
import { ViewActionLane } from '../model/view-action-lane.model';
import { ViewGroupedAction } from '../view-grouped-action.model';
import { ViewRow } from '../view-row.model';

@Component({
    selector: 'cmps-gp-lane',
    templateUrl: './gp-lane.component.html',
})
export class GpLaneComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    @Input() lane: ViewActionLane;

    constructor(private readonly _router: Router) {}

    _trackByRow(_: number, row: ViewRow): number {
        return row.row.userId;
    }

    _onCardClick(row: ViewRow): void {
        const action = this._actionForType(row);
        if (action == null) return;
        if (action.link && action.linkRouterCommands != null) {
            void this._router.navigate(
                action.linkRouterCommands[0],
                action.linkRouterCommands[1] ?? {},
            );
        } else if (action.button) {
            action.buttonClick();
        }
    }

    private _actionForType(row: ViewRow): ViewGroupedAction | null {
        if (row.groupedAction?.actionType === this.lane.actionType)
            return row.groupedAction;
        return (
            row.otherGroupedActions?.find(
                (a) => a.actionType === this.lane.actionType,
            ) ?? null
        );
    }

    _actionCount(row: ViewRow): number {
        if (row.groupedAction?.actionType === this.lane.actionType) {
            return row.groupedAction.count;
        }
        return (
            row.otherGroupedActions?.find(
                (a) => a.actionType === this.lane.actionType,
            )?.count ?? 1
        );
    }
}
